import { useRef, useState } from 'react';
import { BoutonPrincipal, BoutonSecondaire } from '../ui/Primitives';
import { PaveSignature } from '../ui/PaveSignature';
import { usePiegeFocus } from '../../lib/usePiegeFocus';

export function SignatureModal({
  titre,
  sousTitre,
  enCours,
  onAnnuler,
  onValider,
}: {
  titre: string;
  sousTitre: string;
  enCours: boolean;
  onAnnuler: () => void;
  onValider: (trace: string) => void;
}): JSX.Element {
  const [trace, setTrace] = useState<string | null>(null);
  const [consentement, setConsentement] = useState(false);
  // Fenêtre au clavier (TF-341) : `Échap` annule, sauf pendant l'envoi.
  const fenetre = useRef<HTMLDivElement>(null);
  usePiegeFocus(fenetre, true, () => {
    if (!enCours) onAnnuler();
  });

  return (
    <>
      <div className="fixed inset-0 z-40 bg-black/50" onClick={onAnnuler} aria-hidden="true" />
      <div
        ref={fenetre}
        role="dialog"
        aria-modal="true"
        aria-labelledby="titre-signature-emargement"
        tabIndex={-1}
        className="fixed left-1/2 top-1/2 z-50 w-full max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white p-4 sm:p-6 shadow-xl focus:outline-none"
      >
        <h2 id="titre-signature-emargement" className="font-display text-lg font-bold text-codialis-navy">{titre}</h2>
        <p className="mb-4 text-xs text-codialis-gray">{sousTitre}</p>

        <PaveSignature onChanger={setTrace} desactive={enCours} />
        
        <label className="mt-4 flex items-start gap-2 text-xs text-codialis-gray">
          <input
            type="checkbox"
            className="mt-0.5 rounded"
            checked={consentement}
            onChange={(evenement) => setConsentement(evenement.target.checked)}
          />
          J’atteste ma présence. Ma signature est horodatée et conservée comme preuve.
        </label>
        
        <div className="mt-6 flex gap-3">
          <BoutonPrincipal
            onClick={() => trace && onValider(trace)}
            disabled={!trace || !consentement || enCours}
          >
            Valider l’émargement
          </BoutonPrincipal>
          <BoutonSecondaire onClick={onAnnuler} disabled={enCours}>
            Annuler
          </BoutonSecondaire>
        </div>
      </div>
    </>
  );
}
